module.exports = __webpack_public_path__ + "static/media/riskTwoPoints.73d9cae8.mp3";